import axios from '../axiosInstance';

export async function getTreatments({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Treatments/getTreatments', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}
